<template>
  <div>
    <div class="submenu">
      <ul>
        <router-link tag="li" to="/aktivitetslogg">Aktivitetslogg</router-link>
        <router-link tag="li" to="/grafer">Grafer</router-link>
      </ul>
      <div class="clear"></div>
    </div>
                 
    <div class="bootstrap-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-md-3">
            <h4>Enheter</h4>
            
           <!-- <div style="margin-bottom:20px;">
              <div style="margin-bottom:6px;">
                <strong style="cursor:pointer;" >Globalt i ditt hem</strong>
              </div>
              
              <div v-for="type in globalCharts" :style="{ 'padding-left': '6px', 'color': '#000' }">
                <div style="float:left;"><input v-model="checkedBoxes" :disabled="loading" :value="'global' + type.id" type="checkbox" name="hej" @change="showGraphForCapability(type.id, 'global', $event)"> {{ type.name }}</div>
                <div :style="{ 'float': 'right', 'color': (('global-' + type.id) in colors ? colors[('global-' + type.id)] : '#000') }" v-if="('global-' + type.id) in colors">&#9679;</div>
                <div class="clear"></div>
              </div>
            </div>-->          
            
            <div v-for="node in nodes" style="margin-bottom:20px;">
              <div style="margin-bottom:6px;">
                <strong style="cursor:pointer;" @click="markAll(node)">{{ trim(node.name, 20) }}</strong>
              </div>
              
              <div :style="{ 'padding-left': '6px', 'color': '#000' }" v-for="cap in node.capabilities" v-if="cap in $root.capabilities && $root.capabilities[cap].type === 'number'">
                <div style="float:left;"><input v-model="checkedBoxes" :disabled="loading" :value="node.id + '-' + cap" type="checkbox" name="hej" @change="showGraphForCapability(cap, node.id, $event)"> {{ $root.capabilities[cap].name }}</div>
                <div :style="{ 'float': 'right', 'color': ((node.id + '-' + cap) in colors ? colors[(node.id + '-' + cap)] : '#000') }" v-if="(node.id + '-' + cap) in colors">&#9679;</div>
                <div class="clear"></div>
              </div>
            </div>
            
          </div>
          
          <div class="col-md-9">
              <h4>Graferna</h4>
              <div class="descr">När du har valt en typ samt en enhet till vänster kommer du att se grafen här nedanför. Du kan välja flera olika typer i flera olika enheter.</div>
              <hr class="space">
                <!--
                <graph-line-dateblock
                  :width="600"
                  :height="400"
                  :axis-min="0"
                  :axis-max="getMaxValue()"
                  :axis-reverse="false"
                  :axis-format="'HH:mm'"
                  :axis-interval="1000 * 60 * 60 * 4"
                  :labels="labels"
                  :values="values">
                  
                  <note :text="'Line Chart'"></note>
                  <legends :names="names"></legends>
                  <guideline :tooltip-x="true" :tooltip-y="true"></guideline>
              </graph-line-dateblock>
              -->
              <line-chart v-if="!loading" :legend="false" :colors="Object.values(colors)" height="400px" :data="chartData"></line-chart>
              <loading-view v-if="loading"></loading-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import loadingView from './views/loadingView'
  const randomColor = require('randomcolor')

  export default {
    name: 'grafer',
    components: {
      loadingView
    },
    data: () => ({
      checkedBoxes: [],
      loading: false,
      selectedNodesAndTypes: [],
      colors: {},
      labels: [],
      names: ['test'], 
      values: []
    }),
    created () {
      // Här kollar vi om vi skall visa någon specifik enhet direkt
      // när vyn laddas
      if ('node' in this.$route.query && 'capability' in this.$route.query) {
        const node = this.$route.query.node
        const capability = this.$route.query.capability

        this.showGraphForCapability(capability, node, {
          target: {
            checked: true
          }
        })
        
        this.checkedBoxes.push(node + '-' + capability)
      }
    },
    methods: {
      getMaxValue () {
        return this.values.length ? Math.max(...this.values) + 5 : 0
      },

      showGraphForCapability (capability, nodeId, e) {
        const checked = e.target.checked
        const cID = (nodeId + '-' + capability)
        
        // Kolla om vi har markerat eller avmarkerat checkbox
        if (checked) {
          let node = {}
          let cap = {}

          node = this.nodes.find(node => node.id === nodeId)
          cap = this.$root.capabilities[capability]

          let point = {
            name: node.name + ' / ' + cap.name,
            id: cID,
            data: []
          }

          this.colors[point.id] = this.generateColor()

          this.loading = true
          
          if (this.$root.gotNXT) {
            this.labels = []

            HTTP.get('sensor/' + nodeId  + '/' + capability + '?days=1')
            .then(res => res.data)
            .then(json => {
              const data = json.split('\n')
              const totalCount = data.length
              
              let i = 0
              data.forEach(line => {
                let [ time, value ] = line.split(',')

                time = parseInt(time)
                value = parseFloat(value)

                if (isNaN(value)) return
              
                point.data.push([new Date(time), value])

                this.labels.push(new Date(time))
                this.values.push(value)

                i++
              }) 
              
              this.selectedNodesAndTypes.push(point)
              this.loading = false
            })
          } else {
            let whereArray = []
            
            whereArray.push('(name=\'' + capability + '\')')
            whereArray.push('sourceNode=' + nodeId)        

            HTTP.get('eventlog?where=' + whereArray.join(' and '))
            .then(res => res.data)
            .then(json => {
              point.data = json.map(item => {
                return [
                  item.time,
                  item.value
                ]
              })

              console.log(point)

              this.selectedNodesAndTypes.push(point)
              this.loading = false
            })

          }
        } else {
          // Här ska vi ta bort den eftersom användaren har avmarkerat
          const findIndex = this.selectedNodesAndTypes.findIndex(item => item.id === cID)
          this.selectedNodesAndTypes.splice(findIndex, 1)
          
          delete this.colors[cID]
        }
      },
      
      /**
        Trimmar en sträng så den bara blir max XX tecken
      */
      trim (string, length) {
        return string.length > length ? string.substr(0, length) + '...' : string
      },

      /**
        För att man skall kunna hoppa till en nod när man trycker
        på dess namn i listan till vänster.
      */
      goToNode (nodeId) {
        this.$router.push({
          name: 'enhet',
          params: {
            id: nodeId
          }
        })
      },

      /**
        Markerar alla capabilities för en nod och visar dessa
        i grafen.
      */
      markAll (node) {
        node.capabilities.forEach(cap => {
          if (cap in this.$root.capabilities) {
            const capability = this.$root.capabilities[cap]
            
            // Kolla så att det är number, annars vill har vi inte
            // möjlighet att visa grafer.
            if (capability.type === 'number') {
              // Hämta all information
              this.showGraphForCapability(cap, node.id, {
                target: {
                  checked: true
                }
              })
              
              // Gör att alla checkboxar kryssas i
              this.checkedBoxes.push(node.id + ':' + cap)
            }
          }
        })
      },
          
      /**
        En funktion för att generera en färg som sedan används för att
        markera enheten i listan till vänster.
      */        
      generateColor () {
        return randomColor({
         luminosity: 'bright',
         format: 'hex' // e.g. 'rgb(225,200,20)'
        })
      }
    },
    computed: {
      capabilities () {
        return Object.keys(this.$root.capabilities).filter(cap => {
          const capability = this.$root.capabilities[cap]
          return (capability.type === 'number')
        })  
      },
      
      nodes () {
        return this.$root.data.nodes.filter(node => (!node.hideInApp && node.capabilities.some(cap => this.capabilities.includes(cap))))
      },
      
      chartData () {
        return this.selectedNodesAndTypes
      }
    },
    destroyed () {}
  }
</script>


// WEBPACK FOOTER //
// src/components/grafer.vue